// This is meant to be used when the component is used outside of a configured router (i.e. <Route path="/:company/:project" component={...}/>)
import { matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import { compose, withProps } from 'recompose';

const withProjectParams = compose(
  withRouter,
  withProps(({ location }) => {
    const { params } = matchPath(location.pathname, {
      path: '/:company/:project',
    });

    return {
      project: params.project,
      company: params.company,
    };
  }),
);

export default withProjectParams;
